// courses/my-model
import { getData } from 'src/services/RestApi';
import { formatDate } from 'src/utils/date-locale';
import { formatCode, formatDecimal, formatPhone } from 'src/utils/formatters';
import { parseStringToArrayVL } from 'src/utils/string-parsers';

export const getList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/course/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  result.forEach((element) => {
    element.openingDay = formatDate(element.openingDay, 'dd/MM/yyyy');
    element.closingDay = formatDate(element.closingDay, 'dd/MM/yyyy');
    //element.startDay = formatDate(element.startDay, 'dd/MM/yyyy');
    element.courseCode = formatCode(element.courseCode);
  });
  
  return onSuccess(result);
};

export const getMyItem = async (payload) => {
  const myId = payload.id;
  if (!myId) return {};
  
  const { result, error } = await getData('api/course/detail', { courseId: myId, enumType: payload.enumType });
  if(error) return {};

  // Using for access-level
  if(result.statusCode === 'make-list'){
    result.myAccess = {"itemClick": false, "assign": false, "unassign": false};
  }
  
  result.accounts?.forEach(element => {
    element.phone = formatPhone(element.phone);
  });

  return result;
};
